export default function determineUnitOfMeasure(countryCode) {
  // thought about using countryCode?.toUpperCase() but since cart country is already capitalized
  // as well as shopInstance.country, unsure if we should add extra code to ensure capitalizing
  // before we check or account for lowercase inputs.. feedback welcome
  return countryCode === 'US' || countryCode === 'GB' ? 'mi' : 'km';
}